// Docs: IMPLEMENTATION.md §3.3 (frontend cross-cutting hooks).
// Which shell wraps the current viewport: 'coach' (<768px, bottom tab bar +
// center ▶) or 'studio' (≥768px, sidebar rail + ⌘K palette). 768 matches
// Tailwind's `md:` breakpoint so CSS and JS agree on the single cutover.
import { useEffect, useState } from 'react';

const QUERY = '(min-width: 768px)';

export function useShell() {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : true,
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isDesktop ? 'studio' : 'coach';
}
